import { Mail, Star } from "lucide-react";

interface LastWeekLeader {
  userName: string;
  messageCount: number;
}

interface LastWeekLeaderFooterProps {
  leader: LastWeekLeader;
}

/**
 * Displays the previous week's top message sender below the leaderboard.
 * @param props - The last week's leader data
 * @returns A styled footer row
 */
export function LastWeekLeaderFooter({ leader }: LastWeekLeaderFooterProps) {
  return (
    <div className="mt-1">
      <div className="border-t" />
      <div className="flex items-center gap-3 px-2 py-2.5">
        <Star className="h-4 w-4 shrink-0 fill-amber-600 text-amber-600" />
        <span className="flex min-w-0 flex-1 items-center gap-1.5 text-[13px] text-muted-foreground">
          Last week&apos;s leader &middot;{" "}
          <span className="font-semibold text-foreground">
            {leader.userName}
          </span>
        </span>
        <span className="flex shrink-0 items-center gap-1 font-mono text-[13px] tabular-nums text-muted-foreground">
          {leader.messageCount}
          <Mail className="h-3 w-3" />
        </span>
      </div>
    </div>
  );
}
